import { css, useTheme } from "@emotion/react";
import { Fragment } from "react";

import Time from "./Time.jsx";
import useThemeProps from "./useThemeProps.jsx";

export default function TearOffDate(props) {
  const theme = useTheme();
  props = useThemeProps({ props, name: "TearOffDate" });
  let { color = "primary", ...restProps } = props;

  return (
    <Time
      precision="day"
      css={css`
        display: flex;
        flex-flow: column;
        text-align: center;
        width: 52px;
        border-radius: 6px;
        border: 1px solid ${theme.getColor(color)};
        color: ${theme.getColor(color)};
        text-transform: uppercase;
        font-weight: 700;
        letter-spacing: 0.02em;
        overflow: hidden;
        background-color: white;
      `}
      {...restProps}
    >
      {({ getHumanDateString, date, locale }) => (
        <Fragment>
          <span
            css={css`
              font-size: 10px;
              color: white;
              background-color: ${theme.getColor(color)};
              line-height: 18px;
            `}
          >
            {getHumanDateString(date, locale, { month: "short" })}
          </span>
          <span
            css={css`
              font-size: 25px;
              line-height: 34px;
              letter-spacing: 0.5px;
            `}
          >
            {getHumanDateString(date, locale, { day: "numeric" }).padStart(
              2,
              "0",
            )}
          </span>
        </Fragment>
      )}
    </Time>
  );
}
